import BlankTabIconWhite from '@assets/images/common/icon/blank-tab/blank-tab-white.svg';
import MenuDoOpen from '@assets/images/common/icon/menu/menu-do-open.svg';
import ThreePointIconWhite from '@assets/images/common/icon/three-point/white.svg';
import { SHARED_URL } from '@src/routes/shared';
import TenantMobileSidebar from '@src/ui/templates/Tenant/components/MobileHeader/TenantMobileSidebar';
import TenantMobileUserNavigationMenu from '@src/ui/templates/Tenant/components/MobileHeader/TenantMobileUserNavigationMenu';
import React, { useLayoutEffect, useState } from 'react';

// import TenantNotification from './TenantNotification';

const TenantMobileHeader: React.FC = () => {
  const [isUserNavigationDrawerOpen, setIsUserNavigationDrawerOpen] = useState(false);
  const [isMobileSidebarDrawerOpen, setIsMobileSideBarDrawerOpen] = useState(false);
  const handleMenuToggle = () => {
    setIsUserNavigationDrawerOpen((prev) => {
      const next = !prev;
      const el = document.documentElement;
      if (next) {
        el.style.overflowX = 'hidden';
        document.body.style.overflowX = 'hidden';
      } else {
        el.style.overflowX = '';
        document.body.style.overflowX = '';
      }
      return next;
    });
  };
  const handleCloseDrawer = () => {
    setIsUserNavigationDrawerOpen(false);
    document.documentElement.style.overflowX = '';
    document.body.style.overflowX = '';
  };

  const handleSidebarMenuToggle = () => {
    setIsMobileSideBarDrawerOpen((prev) => !prev);
  };
  const handleCloseSidebar = () => {
    setIsMobileSideBarDrawerOpen(false);
    document.documentElement.style.overflowX = '';
    document.body.style.overflowX = '';
  };

  const [vw, setVw] = useState<number>();

  useLayoutEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const update = () => {
      const w = Math.round(window.visualViewport?.width ?? window.innerWidth);
      setVw(w);
    };
    update();

    // visualViewport は resize / scroll の両方で幅が変わる
    const vv = window.visualViewport || null;
    vv?.addEventListener('resize', update);
    vv?.addEventListener('scroll', update);
    window.addEventListener('orientationchange', update);
    window.addEventListener('resize', update);

    return () => {
      vv?.removeEventListener('resize', update);
      vv?.removeEventListener('scroll', update);
      window.removeEventListener('orientationchange', update);
      window.removeEventListener('resize', update);
    };
  }, []);

  return (
    <>
      <header
        className='fixed top-0 z-[9999] flex h-[60px] items-center border-b border-solid border-b-white bg-primary-800'
        style={{ width: vw ? `${vw}px` : undefined }}
      >
        <div className='flex h-full flex-1 items-center overflow-hidden text-[13px] text-white'>
          <div className='flex h-full items-center border-r border-white p-2'>
            <button
              type='button'
              className='grid w-[45px] place-items-center'
              onClick={handleSidebarMenuToggle}
              aria-expanded={isMobileSidebarDrawerOpen}
              aria-label='メニューを開く'
            >
              <img
                src={MenuDoOpen}
                alt='メニューを開く'
                width='24'
                height='24'
              />
            </button>
          </div>
          <a
            href={SHARED_URL.COMMUNITY_DEFAULT_CHANNEL}
            target='_blank'
            rel='noreferrer'
            className='flex h-full items-center gap-1 border-b-2 border-transparent px-4 py-2'
          >
            <span className='break-words leading-none'>オンラインコミュニティ</span>
            <img
              src={BlankTabIconWhite}
              alt=''
              width='16'
              height='16'
              className='size-4'
            />
          </a>
        </div>
        <div className='flex shrink-0 items-center'>
          {/* in-app通知実装時に復活させる */}
          {/* <div className='grid w-[60px] place-items-center'>
            <TenantNotification />
          </div> */}
          <button
            type='button'
            className='grid w-[60px] place-items-center'
            onClick={handleMenuToggle}
            aria-expanded={isUserNavigationDrawerOpen}
            aria-label='メニューを開く'
          >
            <img
              src={ThreePointIconWhite}
              alt='メニューを開く'
              width='24'
              height='24'
            />
          </button>
        </div>
      </header>
      <TenantMobileSidebar
        isOpen={isMobileSidebarDrawerOpen}
        onClose={handleCloseSidebar}
        vw={vw}
      />
      <TenantMobileUserNavigationMenu
        isOpen={isUserNavigationDrawerOpen}
        onClose={handleCloseDrawer}
        vw={vw}
      />
    </>
  );
};

export default TenantMobileHeader;
